import { stringToColour, edgeColour } from "./graphUtils.js";

export class NewConnectionGraph {
  constructor(userMap, messageMap) {
    // set firstMessageOn and lastMessageOn for each cohort
    Object.keys(messageMap).forEach($sent_by => {
      Object.keys(messageMap[$sent_by]).forEach($sent_to => {
        messageMap[$sent_by][$sent_to].forEach(m => {
          m = new Date(m);

          if (!this.firstMessageOn) this.firstMessageOn = m;
          if (!this.lastMessageOn) this.lastMessageOn = m;

          if (m < this.firstMessageOn) this.firstMessageOn = m;
          if (m > this.lastMessageOn) this.lastMessageOn = m;
        });
      });
    });

    this.userMap = userMap;
    this.messageMap = messageMap;
  }

  makeNodeAndEdgeMaps(userMap = {}, messageMap = {}) {
    const nodeMap = JSON.parse(JSON.stringify(userMap));

    Object.keys(nodeMap).forEach(key => {
      nodeMap[key]["sent"] = 0;
      nodeMap[key]["received"] = 0;
    });

    const edgeMap = {};

    Object.keys(messageMap).forEach($sent_by => {
      Object.keys(messageMap[$sent_by]).forEach($sent_to => {
        messageMap[$sent_by][$sent_to].forEach(() => {
          if (!nodeMap[$sent_by] || !nodeMap[$sent_to]) return;

          let a = $sent_by,
            b = $sent_to;

          if ($sent_by < $sent_to) {
            a = $sent_to;
            b = $sent_by;
          }

          // count of messages between a and b
          if (!edgeMap[a]) edgeMap[a] = {};
          if (!edgeMap[a][b]) edgeMap[a][b] = 0;

          edgeMap[a][b] += 1;

          // track how many messages were sent and received by a and b
          nodeMap[$sent_by]["sent"] += 1;
          nodeMap[$sent_to]["received"] += 1;
        });
      });
    });

    return { nodeMap, edgeMap };
  }

  // filters an array of messages
  filterMessageMapByDate(messageMap, from = new Date(0), to = new Date()) {
    let mmap = JSON.parse(JSON.stringify(messageMap));

    Object.keys(mmap).forEach($sent_by => {
      Object.keys(mmap[$sent_by]).forEach($sent_to => {
        mmap[$sent_by][$sent_to] = mmap[$sent_by][$sent_to].filter(m => {
          const mdate = new Date(m);
          return from < mdate && mdate < to;
        });
      });
    });

    return mmap;
  }

  filterUserMapByName(userMap, names) {
    let umap = JSON.parse(JSON.stringify(userMap));

    names.forEach(n => {
      const id = Object.keys(umap).find(key => umap[key]["fullname"] === n);
      delete umap[id];
    });

    return umap;
  }

  getGraph({ filters = {} }) {
    let userMap = this.userMap;

    userMap = this.filterUserMapByName(userMap, filters.exclude_names);

    let messageMap = this.filterMessageMapByDate(
      this.messageMap,
      filters.message_from,
      filters.message_to
    );

    const g = {
      nodes: [],
      edges: []
    };

    let { nodeMap, edgeMap } = this.makeNodeAndEdgeMaps(userMap, messageMap);

    // filter out people who have no messages
    Object.keys(nodeMap).forEach(key => {
      const { sent, received } = nodeMap[key];
      if (sent + received < 1) {
        delete nodeMap[key];
      }
    });

    // Generate a random graph:
    Object.keys(nodeMap).forEach(key => {
      const { fullname, image, sent, received } = nodeMap[key];
      g.nodes.push({
        id: key,
        type: "image",
        label: fullname,
        x: Math.random(),
        y: Math.random(),
        size: sent + received,
        color: stringToColour(fullname),
        url: image
      });
    });

    Object.keys(edgeMap).forEach(source => {
      Object.keys(edgeMap[source]).forEach(target => {
        if (nodeMap[source] && nodeMap[target])
          g.edges.push({
            id: `${source}-${target}`,
            source,
            target,
            size: edgeMap[source][target],
            color: edgeColour(edgeMap[source][target]),
            label: `${edgeMap[source][target]} messages`
          });
      });
    });

    return g;
  }
}
